import React from 'react';
import ApiDocument from "../../code/api/ApiDocument";
import BidPeriodFileGroupInfo from "../../code/models/BidPeriodFileGroupInfo";
import AwardReportInfo from "../../code/models/AwardReportInfo";
import RequestParameter from "../../code/models/RequestParameter";

interface IAdminAwardReportEmail {
    awardReportInfo: AwardReportInfo;
    onRefreshRequest: Function;
}


export default function AdminAwardReportEmail({ awardReportInfo, onRefreshRequest }: IAdminAwardReportEmail) {
    const [currentFileGroup, setCurrentFileGroup] = React.useState<BidPeriodFileGroupInfo | null | undefined>();
    const [disableImportButton, setDisableImportButton] = React.useState<boolean>(false);
    const [resend, setResend] = React.useState<boolean>(false);
    const [selectedPosition, setSelectedPosition] = React.useState<string>("");

    React.useEffect(() => {
        var fg = awardReportInfo.fileGroup || awardReportInfo.lastFileGroup;
        setCurrentFileGroup(fg);
    }, []);

    function handleEmailAwardReports() {
        setDisableImportButton(true);
        if (!!awardReportInfo.fileGroup || !!awardReportInfo.lastFileGroup) {
            let params: RequestParameter[] = [
                { parameterName: "PilotPosition", stringVaue: selectedPosition },
                { parameterName: "ForceResend", boolVaue: resend },
                { parameterName: "previousBidPeriod", boolVaue: true }
            ];

            ApiDocument.queueEmailServiceRequest("award-report", params).then(resp => {
                onRefreshRequest();
            }).finally(() => {
                setDisableImportButton(false);
            });
        }
    }

    function getStatus(): string {
        return currentFileGroup?.groupStatus === 'Deleted' ? "Closed" : (currentFileGroup?.groupStatus || "");
    }

    return (
        <React.Fragment>
            <div>
                <span className="creditrange-label">Last Import Date:</span>
                {!awardReportInfo.importRequest &&
                    <span className="creditrange-data">None for this bid period.</span>}
                {!!awardReportInfo.importRequest &&
                    <span className="creditrange-data">{new Date(awardReportInfo.importRequest?.statusDate).toLocaleString()}</span>}
            </div>
            <div>
                <span className="creditrange-label">Last Import Status:</span>
                {!awardReportInfo.importRequest && <span className="creditrange-data">N/A</span>}
                {!!awardReportInfo.importRequest && <span className="creditrange-data">{awardReportInfo.importRequest?.status}</span>}
            </div>
            <div>
                <span className="creditrange-label">Last Import Message:</span>
                {!awardReportInfo.importRequest && <span className="creditrange-data">N/A</span>}
                {!!awardReportInfo.importRequest && <span className="creditrange-data">{awardReportInfo.importRequest?.statusMessage}</span>}
            </div>
            <br />
            <div>
                <span className="creditrange-label">Last Report Group Date:</span>
                {!currentFileGroup && <span className="creditrange-data">None for this bid period.</span>}
                {!!currentFileGroup &&
                    <span className="creditrange-data">{new Date(currentFileGroup.statusDate).toLocaleString()}</span>}
            </div>
            <div>
                <span className="creditrange-label">Last Report Group Status:</span>
                {!currentFileGroup && <span className="creditrange-data">N/A</span>}
                {!!currentFileGroup && <span className="creditrange-data">{getStatus()}</span>}
            </div>
            <div>
                <span className="creditrange-label">Total Report Files:</span>
                {!currentFileGroup && <span className="creditrange-data">N/A</span>}
                {!!currentFileGroup && <span className="creditrange-data">{currentFileGroup.bidPeriodFiles.length}</span>}
            </div>
            <div className="awardreport-emailreports">
                <div>
                    <label htmlFor="positionSelect" className="form-label">Position</label>
                    <select className="form-select" id="positionSelect"
                        defaultValue={""} onChange={(e) => {
                            setSelectedPosition(e.target.value);
                        }}>
                        <option value={""}>Select</option>
                        <option value={"CA"}>Captains</option>
                        <option value={"FO"}>First Officers</option>
                    </select>
                </div>
                <div className="mt-3">
                    <input type="checkbox" id="resendCheckbox"
                        defaultChecked={false}
                        onChange={(e) => {
                            setResend(e.target.checked);
                        }}></input>
                    <label htmlFor="resendCheckbox" className="form-label ms-1">Resend if already sent</label>
                </div>
                <button className="btn btn-primary btn-md mt-3" disabled={disableImportButton || !selectedPosition}
                    onClick={handleEmailAwardReports}>Email Reports</button>
            </div>
        </React.Fragment>
    )
}

